/**
 * @generated SignedSource<<7986424b7e85e3e4c837ecb1d1017dc4>>
 * @relayHash f3fe3f99f0358b6c9fc75a87e47efe41
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ccc8000f877895f36b3ed559d71f3caea6440dc8d91730d818b11a15e7ef8c00

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type FieldsPageContentQuery$variables = {
  cloudId: string;
  preloadedFieldId: string;
  projectKey: string;
  shouldEnforceLimits: boolean;
  shouldPreloadField: boolean;
  shouldUseGuidedAutonomy: boolean;
};
export type FieldsPageContentQuery$data = {
  readonly jira: {
    readonly jiraProjectByKey: {
      readonly isExplicitFieldAssociationsEnabled: boolean | null;
      readonly " $fragmentSpreads": FragmentRefs<"DeepLinkSidebar" | "FieldsPageHeader">;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"FieldsPageHeader_limits">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"FieldsTable">;
};
export type FieldsPageContentQuery = {
  response: FieldsPageContentQuery$data;
  variables: FieldsPageContentQuery$variables;
};
({
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierGuidedAutonomyEapRelayProvider": includeGuidedAutonomyCapabilities_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcthorcolourfulsingleselectfieldsexperimentrelayprovider": includeSingleSelectColorField_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierFormulaFieldD2D3Relayprovider": isFormulaFieldD2D3Enabled_provider
} as {
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierFormulaFieldD2D3Relayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierGuidedAutonomyEapRelayProvider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcthorcolourfulsingleselectfieldsexperimentrelayprovider: {
    readonly get: () => boolean;
  };
});

import isFormulaFieldD2D3Enabled_provider from '@jira/platform__graphql-relay-provider/src/FrontierFormulaFieldD2D3Relayprovider';
import includeGuidedAutonomyCapabilities_provider from '@jira/platform__graphql-relay-provider/src/FrontierGuidedAutonomyEapRelayProvider';
import includeSingleSelectColorField_provider from '@jira/platform__graphql-relay-provider/src/thor-colourful-single-select-fields-experiment.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "preloadedFieldId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldEnforceLimits"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldPreloadField"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldUseGuidedAutonomy"
},
v6 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v7 = {
  "kind": "Variable",
  "name": "shouldEnforceLimits",
  "variableName": "shouldEnforceLimits"
},
v8 = [
  (v6/*: any*/),
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "projectKey"
  }
],
v9 = {
  "kind": "ScalarField",
  "name": "isExplicitFieldAssociationsEnabled"
},
v10 = {
  "kind": "ScalarField",
  "name": "name"
},
v11 = {
  "kind": "ScalarField",
  "name": "key"
},
v12 = {
  "kind": "ScalarField",
  "name": "id"
},
v13 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 30
  }
],
v14 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v15 = {
  "kind": "ScalarField",
  "name": "scope"
},
v16 = {
  "kind": "ScalarField",
  "name": "typeName"
},
v17 = {
  "kind": "ScalarField",
  "name": "description"
},
v18 = {
  "kind": "ScalarField",
  "name": "typeKey"
},
v19 = {
  "kind": "ScalarField",
  "name": "hasMissingConfiguration"
},
v20 = {
  "kind": "ScalarField",
  "name": "canRemove"
},
v21 = {
  "kind": "ScalarField",
  "name": "canEdit"
},
v22 = {
  "kind": "ScalarField",
  "name": "canModifyOptions"
},
v23 = {
  "concreteType": "JiraFieldOptionConnection",
  "kind": "LinkedField",
  "name": "fieldOptions",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraFieldOptionEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "JiraFieldOption",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "optionId"
            },
            {
              "kind": "ScalarField",
              "name": "parentOptionId"
            },
            {
              "kind": "ScalarField",
              "name": "value"
            },
            {
              "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcthorcolourfulsingleselectfieldsexperimentrelayprovider",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "concreteType": "JiraColor",
                  "kind": "LinkedField",
                  "name": "color",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "colorKey"
                    },
                    (v12/*: any*/)
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
},
v24 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v25 = {
  "kind": "LinkedField",
  "name": "fieldFormatConfig",
  "plural": false,
  "selections": [
    (v24/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "formatStyle"
        },
        {
          "kind": "ScalarField",
          "name": "formatUnit"
        },
        {
          "kind": "ScalarField",
          "name": "formatDecimals"
        },
        {
          "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierFormulaFieldD2D3Relayprovider",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "durationUnits"
            }
          ]
        }
      ],
      "type": "JiraNumberFieldFormatConfig"
    }
  ]
},
v26 = [
  {
    "concreteType": "JiraProjectCapabilities",
    "kind": "LinkedField",
    "name": "capabilities",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "allowLocalFields"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "FieldsPageContentQuery",
    "selections": [
      {
        "args": [
          (v6/*: any*/),
          {
            "kind": "Variable",
            "name": "projectKey",
            "variableName": "projectKey"
          },
          (v7/*: any*/),
          {
            "kind": "Variable",
            "name": "shouldUseGuidedAutonomy",
            "variableName": "shouldUseGuidedAutonomy"
          }
        ],
        "kind": "FragmentSpread",
        "name": "FieldsTable"
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": [
              (v6/*: any*/),
              (v7/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "FieldsPageHeader_limits"
          },
          {
            "args": (v8/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              {
                "args": [
                  (v7/*: any*/)
                ],
                "kind": "FragmentSpread",
                "name": "FieldsPageHeader"
              },
              {
                "condition": "shouldPreloadField",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "preloadedFieldId",
                        "variableName": "preloadedFieldId"
                      }
                    ],
                    "kind": "FragmentSpread",
                    "name": "DeepLinkSidebar"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierGuidedAutonomyEapRelayProvider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcthorcolourfulsingleselectfieldsexperimentrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierFormulaFieldD2D3Relayprovider"
      }
    ],
    "kind": "Operation",
    "name": "FieldsPageContentQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v8/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              {
                "concreteType": "JiraAvatar",
                "kind": "LinkedField",
                "name": "avatar",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "xsmall"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "projectId"
              },
              {
                "kind": "ScalarField",
                "name": "projectType"
              },
              (v11/*: any*/),
              {
                "kind": "ScalarField",
                "name": "optionsPerFieldLimit"
              },
              {
                "concreteType": "JiraFieldTypeGroupConnection",
                "kind": "LinkedField",
                "name": "projectFieldTypeGroups",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraFieldTypeGroupEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraFieldTypeGroup",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "displayName"
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "projectScopedFieldsPerProjectLimit"
              },
              {
                "kind": "ScalarField",
                "name": "projectScopedFieldsCount"
              },
              (v12/*: any*/),
              {
                "concreteType": "JiraProjectWithIssueTypeIds",
                "kind": "LinkedField",
                "name": "projectWithVisibleIssueTypeIds",
                "plural": false,
                "selections": [
                  {
                    "args": (v13/*: any*/),
                    "concreteType": "JiraFieldAssociationWithIssueTypesConnection",
                    "kind": "LinkedField",
                    "name": "fieldAssociationWithIssueTypes",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraFieldAssociationWithIssueTypesEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraFieldAssociationWithIssueTypes",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v12/*: any*/),
                              {
                                "concreteType": "JiraField",
                                "kind": "LinkedField",
                                "name": "field",
                                "plural": false,
                                "selections": [
                                  (v14/*: any*/),
                                  (v12/*: any*/),
                                  (v10/*: any*/),
                                  (v15/*: any*/),
                                  (v16/*: any*/),
                                  (v17/*: any*/),
                                  (v18/*: any*/)
                                ]
                              },
                              (v19/*: any*/),
                              {
                                "concreteType": "JiraFieldOperation",
                                "kind": "LinkedField",
                                "name": "fieldOperation",
                                "plural": false,
                                "selections": [
                                  (v20/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "canDelete"
                                  },
                                  (v21/*: any*/),
                                  (v22/*: any*/)
                                ]
                              },
                              (v23/*: any*/),
                              (v25/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "isFieldLocked"
                              },
                              (v24/*: any*/)
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "cursor"
                          }
                        ]
                      },
                      {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "endCursor"
                          }
                        ]
                      },
                      {
                        "kind": "ClientExtension",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "__id"
                          }
                        ]
                      }
                    ],
                    "storageKey": "fieldAssociationWithIssueTypes(first:30)"
                  },
                  {
                    "args": (v13/*: any*/),
                    "filters": [
                      "input"
                    ],
                    "handle": "connection",
                    "key": "fieldsTable_fieldAssociationWithIssueTypes",
                    "kind": "LinkedHandle",
                    "name": "fieldAssociationWithIssueTypes"
                  }
                ]
              },
              (v9/*: any*/),
              {
                "condition": "shouldUseGuidedAutonomy",
                "kind": "Condition",
                "passingValue": true,
                "selections": (v26/*: any*/)
              },
              {
                "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierGuidedAutonomyEapRelayProvider",
                "kind": "Condition",
                "passingValue": true,
                "selections": (v26/*: any*/)
              },
              {
                "condition": "shouldEnforceLimits",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "JiraProjectWithIssueTypeIds",
                    "kind": "LinkedField",
                    "name": "projectWithVisibleIssueTypeIds",
                    "plural": false,
                    "selections": [
                      {
                        "alias": "fieldAssociationWithIssueTypesCount",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 1
                          }
                        ],
                        "concreteType": "JiraFieldAssociationWithIssueTypesConnection",
                        "kind": "LinkedField",
                        "name": "fieldAssociationWithIssueTypes",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "totalCount"
                          }
                        ],
                        "storageKey": "fieldAssociationWithIssueTypes(first:1)"
                      }
                    ]
                  }
                ]
              },
              {
                "condition": "shouldPreloadField",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "JiraProjectWithIssueTypeIds",
                    "kind": "LinkedField",
                    "name": "projectWithVisibleIssueTypeIds",
                    "plural": false,
                    "selections": [
                      {
                        "alias": "preloadedField",
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "fieldId",
                            "variableName": "preloadedFieldId"
                          }
                        ],
                        "concreteType": "JiraFieldAssociationWithIssueTypes",
                        "kind": "LinkedField",
                        "name": "fieldAssociationWithIssueTypesByFieldId",
                        "plural": false,
                        "selections": [
                          (v12/*: any*/),
                          {
                            "concreteType": "JiraField",
                            "kind": "LinkedField",
                            "name": "field",
                            "plural": false,
                            "selections": [
                              (v24/*: any*/),
                              (v12/*: any*/),
                              (v14/*: any*/),
                              (v10/*: any*/),
                              (v17/*: any*/),
                              (v18/*: any*/),
                              (v15/*: any*/),
                              (v16/*: any*/)
                            ]
                          },
                          (v23/*: any*/),
                          (v19/*: any*/),
                          {
                            "concreteType": "JiraFieldOperation",
                            "kind": "LinkedField",
                            "name": "fieldOperation",
                            "plural": false,
                            "selections": [
                              (v20/*: any*/),
                              (v21/*: any*/),
                              (v22/*: any*/)
                            ]
                          },
                          (v25/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "condition": "shouldEnforceLimits",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  (v6/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "filterKeys",
                    "value": [
                      "fields.per.project.limit"
                    ]
                  }
                ],
                "concreteType": "JiraResourceUsageMetricLimitValue",
                "kind": "LinkedField",
                "name": "limitValues",
                "plural": true,
                "selections": [
                  (v11/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "limitValue"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "limitEnforced"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "ccc8000f877895f36b3ed559d71f3caea6440dc8d91730d818b11a15e7ef8c00",
    "metadata": {},
    "name": "FieldsPageContentQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierGuidedAutonomyEapRelayProvider": includeGuidedAutonomyCapabilities_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcthorcolourfulsingleselectfieldsexperimentrelayprovider": includeSingleSelectColorField_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierFormulaFieldD2D3Relayprovider": isFormulaFieldD2D3Enabled_provider
    }
  }
};
})();

(node as any).hash = "598940e555852efd80a89e0376d0cd93";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
